import { Component } from '@ecs/Component';

export class WeaponRangeDisplay implements Component {
  readonly type = 'WeaponRangeDisplay';
  
  constructor(
    public showRange: boolean = false,
    public range: number = 0,
    public rangeColor: string = 'rgba(0, 200, 255, 0.15)',
    public rangeStrokeColor: string = 'rgba(0, 200, 255, 0.3)',
    public rangeStyle: 'dashed' | 'solid' = 'dashed'
  ) {}
}